import { z } from 'zod'
import {
  requiredString,
  requiredSelect,
  optionalString,
  optionalNumber,
  optionalPositiveNumber,
  createResourceSchema
} from './common'

export const positionSchema = createResourceSchema({
  name: requiredString('Name'),
  category: optionalString,
  position_type: requiredSelect('Position type'),
  // GeoPosition fields
  hole_id: optionalString,
  lat: optionalNumber,
  lng: optionalNumber,
  walk_time_minutes: optionalPositiveNumber,
  order_promo_text: optionalString,
  // IndoorPosition fields
  table_number: optionalString,
  capacity: optionalPositiveNumber,
  area: optionalString,
  sponsor_ids: z.array(z.string()).optional().default([])
})
